import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const userSlice = createAppSlice({
  name: 'user',
  initialState,
  reducers,
});

export const { setAuthTokens, signOut, setChangingChannels, updateAdminProfile, optBetaFeature } = userSlice.actions;

export default userSlice.reducer;
